var React = require('react');

function BlueTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.64457 5.7889L9.90988 0.689242C10.3874 0.226714 11.165 0.226714 11.6425 0.689242C12.1201 1.15177 12.1201 1.90486 11.6425 2.36738L5.50783 8.30315C5.03028 8.76568 4.25273 8.76568 3.77518 8.30315L0.358849 4.9943C-0.124825 4.52584 -0.124825 3.77869 0.358849 3.31616C0.842523 2.85363 1.61395 2.85363 2.0915 3.31616L4.64457 5.7889Z","fill":"#13273F"}));
}

BlueTick.defaultProps = {"width":"12","height":"9","viewBox":"0 0 12 9","fill":"none"};

module.exports = BlueTick;

BlueTick.default = BlueTick;
